import { useTranslation } from 'react-i18next';
import { EditOutlined } from '@mui/icons-material';
import { Button, Tooltip, Typography } from '@mui/material';
import { useOrganisationUnitTreeContext } from 'shared/features/organisation/providers/organisation-unit-tree-provider';

import LocationRow from 'features/connectors/components/location-row.component';
import { useConnectorsContextProvider } from 'features/connectors/context/connectors-provider';
import { ConnectorType } from 'features/connectors/domain/connector';
import styles from 'features/connectors/views/connector-details/connector-settings/connector-settings-organisation.module.scss';
import LocationsModal from 'features/connectors/views/connector-details/connector-settings/locations-modal/locations-modal.module';

const ConnectorSettingsOrganisation = () => {
  const { t } = useTranslation('connectors');
  const { organisationUnitTree } = useOrganisationUnitTreeContext();
  const { connectorDetailsHook } = useConnectorsContextProvider();

  const { viewingMode, form, isLocationPickerOpen, openLocationPicker } = connectorDetailsHook;

  const rootOrganisationUnitName = organisationUnitTree?.find((x) => !x.parentId)?.name;
  const organisationUnits = form.watch('organisationUnits') || [];

  const connectorType = form.watch('type');
  const isCreation = viewingMode === 'creation';
  const isEditing = viewingMode === 'editing';
  const isVcare = connectorType === ConnectorType.Vcare;
  const isNedap = connectorType === ConnectorType.NedapOns;
  const shouldShowRoot = isVcare;

  return (
    <div className={styles.container}>
      {shouldShowRoot && rootOrganisationUnitName && (
        <Tooltip title={t('details.settings.connectorAlwaysLinkedToRoot')} disableHoverListener={viewingMode === 'viewing'}>
          <Typography variant="subtitle1">{rootOrganisationUnitName}</Typography>
        </Tooltip>
      )}

      {!isCreation && isNedap && (
        <>
          {organisationUnits.map(({ id, name }) => (
            <LocationRow key={id} name={name} />
          ))}

          {isEditing && (
            <Button variant="outlined" onClick={openLocationPicker} startIcon={<EditOutlined />} data-testid="editLocationsButton">
              {t('details.settings.editLocationsButton')}
            </Button>
          )}
        </>
      )}

      {isLocationPickerOpen && <LocationsModal />}
    </div>
  );
};

export default ConnectorSettingsOrganisation;
